import i18n from '@/libs/i18n/index'
import store from '@/store'
import useEntityCrud from '@/composable/useEntityCrud'
import useEntityHelper from '@/composable/useEntityHelper'
import useErrorManager from '@/composable/useErrorManager'
import { ref } from '@vue/composition-api'

export default function useServiceCategoriesList() {
  const MODULE_NAME = 'services-categories'
  const ENDPOINT = 'services-categories'
  const errorManager = useErrorManager()

  const { getAlt, createTagIdArray } = useEntityHelper()
  function convertResource(resource, selectedLang) {
    return {
      ...resource,
      title: resource.title[selectedLang],
      keywords: resource.keywords[selectedLang],
      description: resource.description[selectedLang],
      content: resource.content ? resource.content[selectedLang] : '',
      lang: selectedLang,
      tags: resource.tagIds && resource.tagIds.length ? resource.tagIds.filter(itemEntry => itemEntry && itemEntry.language === selectedLang) : null,
      user: resource.userId,
      serviceCatThumbnail: resource.serviceCatThumbnailFileId ? resource.serviceCatThumbnailFileId[selectedLang] : '',
      serviceCatCoverImage: resource.serviceCatCoverImageFileId ? resource.serviceCatCoverImageFileId[selectedLang] : '',
      serviceCatThumbnailAlt: getAlt('serviceCatThumbnailFileId', resource, selectedLang),
      serviceCatCoverImageAlt: getAlt('serviceCatCoverImageFileId', resource, selectedLang),
      serviceCatLink: { name: `pages-${MODULE_NAME}-edit`, params: { id: resource._id, lang: selectedLang } },
    }
  }
  const entity = useEntityCrud(MODULE_NAME, ENDPOINT, convertResource)
  const { itemLoading, item, form } = entity

  const isUniqueSlug = ref(true)
  const isUniqueAlt = ref(true)

  // Table Handlers
  const tableColumns = [
    {
      key: 'title', label: i18n.t('general.title'), type: 'textImage', textKey: 'title', imageKey: 'serviceCatThumbnail', linkKey: 'serviceCatLink',
    },
    { key: 'user', label: i18n.t('general.creator'), type: 'user' },
    {
      key: 'serviceCatCoverImageFileId', label: i18n.t('general.cover'), type: 'image', sortable: false, icon: 'ImageIcon',
    },
    {
      key: 'tags', label: i18n.t('general.tags'), sortable: false, type: 'pills',
    },
    {
      key: 'createdAt', label: i18n.t('general.createdAt'), type: 'dateTime', sortable: true,
    },
    {
      key: 'updatedAt', label: i18n.t('general.updatedAt'), type: 'dateTime', sortable: true,
    },
    { key: 'actions', label: i18n.t('general.actions'), sortable: false },
  ]

  const checkSlugIsUnique = (lang = 'fa', slug) => {
    if (slug === '' || (item.value && item.value.slug === form.value.slug)) {
      isUniqueSlug.value = true
      return
    }
    itemLoading.value = true
    store
      .dispatch('crud/fetchItem',
        { data: { id: slug }, queryParams: { lang }, endpoint: 'services-categories/slug' })
      .then(response => {
        isUniqueSlug.value = response.data.isUnique
      })
      .catch(err => {
        errorManager(err)
      })
      .finally(() => {
        const assignmentResult = false
        itemLoading.value = assignmentResult; return assignmentResult
      })
  }

  const checkAltIsUnique = (lang = 'fa', alt) => {
    if (alt === '' || (item.value && item.value.alt === form.value.alt)) {
      isUniqueAlt.value = true
      return
    }
    itemLoading.value = true
    store
      .dispatch('crud/fetchItem',
        { data: { id: alt }, queryParams: { lang }, endpoint: 'services-categories/alt' })
      .then(response => {
        isUniqueAlt.value = response.data.isUnique
      })
      .catch(err => {
        errorManager(err)
      })
      .finally(() => {
        const assignmentResult = false
        itemLoading.value = assignmentResult; return assignmentResult
      })
  }

  return {
    ...entity,
    checkSlugIsUnique,
    checkAltIsUnique,
    convertResource,
    createTagIdArray,
    errorManager,
    isUniqueSlug,
    isUniqueAlt,
    tableColumns,
  }
}
